<script setup lang="ts">
const pageLocale = useState<string>('page-locale', () => 'fa')

const availableLocales = [
  { code: 'en', name: 'English' },
  { code: 'fa', name: 'فارسی' },
]
</script>

<template>
  <div class="inline-flex items-center justify-center">
    <UPopover :ui="{ content: 'm-2' }">
      <UButton
        color="neutral"
        variant="ghost"
        size="sm"
        square
        class="rounded-full"
        icon="i-lucide-globe"
        :aria-label="pageLocale === 'fa' ? 'تغییر زبان' : 'Change language'"
      />
      <template #content>
        <div class="flex flex-col w-full min-w-32 gap-1 p-1">
          <UButton
            v-for="loc in availableLocales"
            :key="loc.code"
            color="neutral"
            variant="ghost"
            class="locale-link justify-start"
            :class="{ 'is-active bg-primary/10': loc.code === pageLocale }"
            @click="pageLocale = loc.code"
          >
            {{ loc.name }}
          </UButton>
        </div>
      </template>
    </UPopover>
  </div>
</template>
